var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"empty",rawName:"v-empty",value:(_vm.empty),expression:"empty"}],staticStyle:{"min-height":"100vh"},attrs:{"empty-text":_vm.emptyText}})}
var staticRenderFns = []

export { render, staticRenderFns }